__turbopack_context__.v({
  "ApplyButton": "HowToApply-module-sass-module___2C5EG__ApplyButton",
  "DetailHeading": "HowToApply-module-sass-module___2C5EG__DetailHeading",
  "HowToApply": "HowToApply-module-sass-module___2C5EG__HowToApply",
});
